<template>
  <div class="OnlineLicense">
    <BannerVideo :video-url="$StaticFileUrl + '/mp/video/onlineLicenseVideo.mp4'">
      <div class="title wow fadeInDown" data-wow-duration="1s">在线证件照</div>
      <div class="desc wow fadeInDown" data-wow-duration="1s">600+种证件照规格，智能AI算法，满足各类场景拍摄需求</div>
      <div class="flex-row flex-col-center">
        <div class="btn-red wow flipInX" data-wow-duration="1s" style="margin-top: 100px">立即体验</div>
      </div>
    </BannerVideo>
  </div>
</template>

<script>
import WOW from 'wowjs'
import BannerVideo from '@/components/BannerVideo'

/**
 * @author  XuHongli
 * @date  2022/12/28 10:12
 * @version 1.0
 * @description
 */
export default {
  name: 'OnlineLicense',
  components: {BannerVideo},
  mounted() {
    new WOW.WOW().init()
  }
}
</script>

<style scoped>

</style>
